import {
    BoxedRow,
    ButtonLink,
    Callout,
    IconCalendarEuroRegular,
    IconDataBonusRegular,
    IconEuroSymbolCircleRegular,
    Row,
    RowList,
    Text6,
} from '@telefonica/mistica';
import './index.scss';
import '../../translations/i18n';
import BillingCycle from '../BillingCycle';
import NeedMoreGigs from '../NeedMoreGigs';
import { ISharedProps } from '../../models/interfaces';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import MobileSectionBoxed from '../MobileSectionBoxed';
import navigateParams from '../../utils/navigation/navigateParams';
import { useDispatch } from 'react-redux';
import { getFormatDate, getStringCycle } from '../../utils/dataTransformation/dateConversions';
import { getBonusOffering } from '../../services/ProductService';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';
import { showSnackbar, showStopper } from '../../utils/store/features/user';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import useUserlight from '../../utils/hooks/useUserLight';
import { CardsHome } from '../CardsFlexHome';
import { WarningLine } from '../WarningEsim';
import { getSIMSInfos } from '../../services/ConfigureLineService';
import { InfoSIM } from '../../models/ConfigureLine';
import { useConfigureLineContext } from '../../utils/store/context/configure-line-context/ConfigureLineContext';
import { useQuery } from '@tanstack/react-query';
import useConfigureLine from '../../pages/ConfigureLine/utils/hooks';
import useSimsInfos from '../../utils/hooks/useSimsInfos';

const OnlyMobile: React.FC<ISharedProps> = (dataTab: any) => {
    const navigate = useNavigate();
    const { setIsConvergent, blockedLines, setLineActive } = useConfigureLineContext();
    const { checkRestrictions } = useConfigureLine();
    const { t } = useTranslation();
    const [billing] = useState(dataTab.dataTab.cycleEnded);
    const cicloInfo = getStringCycle(dataTab.dataTab.cycleStarts, dataTab.dataTab.cycleEnds);
    const dispatch = useDispatch();
    const consumptionsDisabled = managementEnvironment().REACT_APP_STOPPER_CONSUMPTIONS_DISABLED;
    const [hasOffering, setHasOffering] = useState(false);
    const fromConvergent: boolean = false;
    const isLight = useUserlight();
    const [dataSims, setDataSims] = useState<InfoSIM[]>([]);
    const { simsInfosRequest } = useSimsInfos();

    localStorage.setItem('storage', JSON.stringify(dataTab.dataTab));
    const number = window.localStorage.getItem('mc-number');
    let productIdSend: any;
    let mobileNumber: string = '';
    if (dataTab) {
        productIdSend = dataTab.dataTab.productId;
        mobileNumber = dataTab.dataTab.number;
    }

    const pendingEsim: InfoSIM[] = dataSims?.filter((pending) => pending.number === mobileNumber)!;

    useEffect(() => {
        simsInfosRequest(setDataSims);
    }, []);

    useEffect(() => {
        setIsConvergent(false);
    }, []);

    useEffect(() => {
        checkRestrictions(dataTab.dataTab.productId);
    }, []);

    useEffect(() => {
        getBonusOffering(productIdSend)
            .then((results: any) => {
                setHasOffering(results.data.length > 0 ? true : false);
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);

    const sendToNative = (url: string) => {
        if (url === '/mobile/extra-expense') {
            if (consumptionsDisabled) {
                dispatch(showStopper());
            } else {
                const isOtherLine = number !== dataTab.dataTab.number;
                if (isLight && isOtherLine) {
                    dispatch(showSnackbar());
                } else {
                    const type = 'modeFlow-backgroundBlue';
                    const url = '/mobile/extra-expense';
                    const title = 'Detalle de gasto extra';
                    const productPsId: string = dataTab.dataTab.productPsId;
                    const queryParams = { productPsId };
                    if (navigateParams(type, url, queryParams, dataTab.dataTab, title)) {
                        sessionStorage.setItem(
                            'breadcrumb',
                            JSON.stringify([{ title: dataTab.dataTab.number, url: window.location.href }]),
                        );
                        navigate(url + '?productPsId=' + productPsId, {
                            state: {
                                number: dataTab.dataTab.number,
                                productPsId,
                            },
                        });
                    }
                }
            }
        } else if (url === '/configure-line') {
            const type = 'modeFlow-backgroundBlue';
            const productId: any = dataTab.dataTab.productId;
            const number: any = dataTab.dataTab.number;
            const multisim: any = dataTab.dataTab.multiSim;
            const title: string = t('lineManagement');
            const queryParams = { productId, phone: number, multisim };
            sessionStorage.setItem('pathOrigin', window.location.href.replace(window.location.origin, ''));
            if (navigateParams(type, url, queryParams, dataTab.dataTab, title)) {
                sessionStorage.setItem(
                    'breadcrumb',
                    JSON.stringify([
                        { title: dataTab.dataTab.number.replaceAll(/\s/g, ''), url: window.location.href },
                    ]),
                );
                setLineActive(productId);
                navigate(url, {
                    state: {
                        phone: dataTab.dataTab.number.replaceAll(/\s/g, ''),
                        productId,
                    },
                });
            }
        } else {
            const type = 'modeFlow-backgroundBlue';
            const queryParams = { productId: dataTab.dataTab.productId };
            const storage = { data: dataTab.dataTab, fromConvergent: fromConvergent, cicle: cicloInfo };
            if (navigateParams(type, url, queryParams, storage)) {
                sessionStorage.setItem(
                    'breadcrumb',
                    JSON.stringify([{ title: dataTab.dataTab.number, url: window.location.href }]),
                );
                navigate(url + '?productId=' + dataTab.dataTab.productId, {
                    state: {
                        number: dataTab.dataTab.number,
                        productId: dataTab.dataTab.productId,
                    },
                });
            }
        }
    };
    return (
        <div className='only-mobile'>
            {billing && (
                <div className='only-mobile__callout'>
                    <Callout
                        icon={<IconCalendarEuroRegular />}
                        title={t('consumptionInformation')}
                        description={t('consumptionInformationDescription')}
                        buttonLink={<ButtonLink onPress={() => {}}>{t('moreInformation')}</ButtonLink>}
                    />
                </div>
            )}

            <div className='only-mobile__number'>
                <Text6>{mobileNumber && formatMobileNumber(mobileNumber)}</Text6>
            </div>
            {
                <WarningLine
                    warningsInfo={pendingEsim}
                    blockedLine={{
                        blocked: blockedLines.includes(dataTab.dataTab.productId),
                        number: dataTab.dataTab.number,
                        productId: dataTab.dataTab.productId,
                    }}
                />
            }
            <div className='only-mobile__content'>
                <div className='only-mobile__content-cards'>
                    <div className='only-mobile__content-cards-consums'>
                        <MobileSectionBoxed
                            data={dataTab.dataTab}
                            title={t('mobileData')}
                            //isDataBonus={dataBonus}
                        ></MobileSectionBoxed>
                    </div>
                    <div className='only-mobile__content-cards-rows'>
                        <RowList>
                            <Row
                                asset={<IconEuroSymbolCircleRegular />}
                                title={t('extraExpense')}
                                badge={dataTab.dataTab.extraSum > 0 ? true : false}
                                onPress={() => {
                                    sendToNative('/mobile/extra-expense');
                                }}
                            ></Row>
                            {dataTab.dataTab.dataBonus && (
                                <Row
                                    asset={<IconDataBonusRegular />}
                                    title={t('checkExtraBonus')}
                                    onPress={() => {
                                        sendToNative('/bonus-extra-details');
                                    }}
                                ></Row>
                            )}
                        </RowList>
                    </div>
                    <div className='only-mobile__content-cards-billingCycle'>
                        <BillingCycle
                            BillingCycle={`${getFormatDate(dataTab.dataTab.cycleStarts, 'DD/MM')} - ${getFormatDate(
                                dataTab.dataTab.cycleEnds,
                                'DD/MM',
                            )} `}
                            closing={`${dataTab.dataTab.cycleEndInDays} ` + t('day')}
                        ></BillingCycle>
                    </div>
                </div>
                <div className='only-mobile__content-cardsInfo'>
                    {hasOffering && !blockedLines.includes(dataTab.dataTab.productId) && (
                        <div className='only-mobile__content-cardsInfo-needMoreGb'>
                            <NeedMoreGigs productId={productIdSend}></NeedMoreGigs>
                        </div>
                    )}
                    <div className='only-mobile__content-cardsInfo-lineServices'>
                        <BoxedRow
                            title={t('lineManagement')}
                            description={t('lineConfigurationDescription')}
                            onPress={() => sendToNative('/configure-line')}
                        ></BoxedRow>
                    </div>
                </div>
            </div>
            <CardsHome product='mobile'></CardsHome>
        </div>
    );
};

export default OnlyMobile;
